module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-25.3b679a09.png";